import React from 'react'
import { abbreviate } from '../../Utils/abbreviators';
import { Link } from 'react-router-dom';
import { localStorageEnums } from '../../constants/LocalStorageEnums';
import Seprator from "../../Images/seprator.png";
import { IconButton } from '@mui/material';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import moment from 'moment';


export const HoveredCard = ({ event, redirectTo, toggle, distance }) => {
    const [openingHours, setOpeningHours] = React.useState(false);
    const onRedirectClick = () => {
        const link=`http://maps.google.com/?q=${redirectTo}`;
        window.open(link, "_blank");
    }
    const isOpen = () => {
        const today = moment().format('ddd');
        const openingHoursData = event?.openingHours ? JSON.parse(`${JSON.parse(event?.openingHours)}`) : null;
        const times = openingHoursData ? openingHoursData[today]?.split(" - ") : [];
        const startDate = times.length > 0 ? moment(`${moment().format("MM/DD/YYYY")} ${times[0]}:00`) : null;
        const endDate = times.length > 0 ? moment(`${moment().format("MM/DD/YYYY")} ${times[1]}:00`) : null;
        if(startDate && endDate && moment() > startDate && moment() < endDate) {
            return 'open now';
        } else {
            return 'closed now';
        }
    }
    const locationStatus = window.localStorage.getItem(localStorageEnums.LOCATIONSTATUS);
    const mainContent = () => {
        return (
            <Link className='marker_div_event_detail' style={{ opacity: !toggle ? '0' : '1' }}>
                <div className='marker_div_event_detail_text'>
                    <span className='marker_div_event_detail_heading' title={event?.name}>{abbreviate(event?.name, 20)}</span>
                    <div className='event_details_location_flex'>
                        <span className='marker_div_hours_text'>{(locationStatus === "granted" && !isNaN(distance)) && `${distance} miles | ${event?.address}`}</span>
                        <span className='marker_div_hours_text'>{isOpen()}</span>
                    </div>
                    <div style={{ display: 'flex', marginTop: '15px', marginLeft: '-20px' }}>
                        <IconButton aria-label="back" variant="outlined"
                            style={{ display: 'flex', color: "#538103", flexDirection: 'column', minWidth: '50%'}}
                            sx={{
                                ml: 1,
                                "&.MuiButtonBase-root:hover": {
                                  bgcolor: "transparent"
                                }
                            }}
                            onClick={onRedirectClick} >
                            <NearMeOutlinedIcon fontSize='medium'/>
                            <div className='marker_div_event_detail_heading italic'>Directions</div>
                        </IconButton>
                        <img alt='Seprator' src={Seprator} width={"2px"} height={"60px"} style={{ left: '5px', position: 'relative' }}/>
                        <IconButton aria-label="back" variant="outlined"
                            style={{ display: 'flex', color: "#538103", flexDirection: 'column', minWidth: '50%' }}
                            sx={{
                                ml: 1,
                                "&.MuiButtonBase-root:hover": {
                                  bgcolor: "transparent"
                                }
                            }}
                            onClick={() => setOpeningHours(!openingHours)} >
                            <WatchLaterOutlinedIcon fontSize='medium'/>
                            <div className='marker_div_event_detail_heading italic'>Hours</div>
                        </IconButton>
                    </div>
                </div>
            </Link>
        )
    }
    const subContent = () => {
        const openingHoursData = event?.openingHours ? JSON.parse(`${JSON.parse(event?.openingHours)}`) : null;
        // const openingHoursData = JSON.parse(event?.openingHours);
        return (
            <Link className='marker_div_event_detail' style={{ opacity: !toggle ? '0' : '1' }}>
                <IconButton aria-label="back" variant="outlined" color="success"
                    style={{ display: 'flex', flexDirection: 'column', marginLeft: '-2px', padding: '0px'}}
                    sx={{
                        ml: 1,
                        "&.MuiButtonBase-root:hover": {
                          bgcolor: "transparent"
                        }
                    }}
                    onClick={() => setOpeningHours(!openingHours)} >
                    <ArrowBackIosNewRoundedIcon fontSize='medium'/>
                </IconButton>
                <div className='event_details_location_flex' style={{ margin: '8px 3px 3px 3px' }}>
                    <span className='marker_div_event_detail_heading'>Opening hours</span>
                    <p className='marker_div_hours_text'>Mon {openingHoursData?.Mon ? openingHoursData.Mon : "Closed"}</p>
                    <p className='marker_div_hours_text'>Tue {openingHoursData?.Tue ? openingHoursData.Tue : "Closed"}</p>
                    <p className='marker_div_hours_text'>Wed {openingHoursData?.Wed ? openingHoursData.Wed : "Closed"}</p>
                    <p className='marker_div_hours_text'>Thu {openingHoursData?.Thu ? openingHoursData.Thu : "Closed"}</p>
                    <p className='marker_div_hours_text'>Fri {openingHoursData?.Fri ? openingHoursData.Fri : "Closed"}</p>
                    <p className='marker_div_hours_text'>Sat {openingHoursData?.Sat ? openingHoursData.Sat : "Closed"}</p>
                    <p className='marker_div_hours_text'>Sun {openingHoursData?.Sun ? openingHoursData.Sun : "Closed"}</p>
                </div>
            </Link>
        )
    }
    return (
        openingHours ? subContent() : mainContent()
    )
}
